import { Utilities } from "@learningblocks/exp-constants";
const { TOUR_PROPERTIES, setLocalStorageItem } = Utilities;

export function endTour(state) {
  return {
    ...state,
    ...setTourFlase(),
  };
}
function setTourFlase() {
  setLocalStorageItem(TOUR_PROPERTIES.IS_EXPERIMENTAL_DESIGN_FINISHED, true);
  return { tour: false };
}
